// Query key factory for address-related queries
const scopes = {
  sublocalities: "sublocalities",
  addressCoordinates: "addressCoordinates",
  patientCoordinates: "patientCoordinates",
  geojson: "geojson",
  appointmentCoordinates: "appointmentCoordinates",
  closestAppointments: "closestAppointments",
  closestContinuousAppointments: "closestContinuousAppointments",
};

export const AddressKeys = {
  sublocalities: {
    scope: scopes.sublocalities,
    all: (locationId?: string) => [scopes.sublocalities, { locationId}] as const,
  },
  addressCoordinates: {
    scope: scopes.addressCoordinates,
    all: () => [scopes.addressCoordinates] as const,
    byIds: (addressIds: string[]) => [scopes.addressCoordinates, {addressIds}] as const,
  },
  patientCoordinates: {
    scope: scopes.patientCoordinates,
    all: (locationId?: string) => [scopes.patientCoordinates, { locationId }] as const,
  },
  geojson: {
    scope: scopes.geojson,
    all: (locationId?: string) => [scopes.geojson, { locationId}] as const,
  },
  appointmentCoordinates: {
    scope: scopes.appointmentCoordinates,
    byIds: (appointmentIds: string[]) => [scopes.appointmentCoordinates, { appointmentIds }] as const,
  },
  closestAppointments: {
    scope: scopes.closestAppointments,
    byWeek: (
      targetRef: string,
      weekStartDate: string,
      selectedDate: string,
      locationId?: string,
    ) =>
      [
        scopes.closestAppointments,
        { targetRef, weekStartDate, selectedDate, locationId },
      ] as const,
  },
  closestContinuousAppointments: {
    scope: scopes.closestContinuousAppointments,
    byDay: (targetRef: string, dayOfWeek: number | undefined, locationId?: string) =>
      [scopes.closestContinuousAppointments, { targetRef, dayOfWeek, locationId }] as const,
  },
};
